export default __webpack_public_path__ + "aab3994e3b346089e3e9b175d537b520.svg";